import type { ReactNode } from 'react';

/** Ilustración propia y sencilla: un camino de puntos que asciende hacia una meta. */
function EmptyArt() {
  return (
    <svg className="empty__art" viewBox="0 0 120 120" aria-hidden="true">
      <circle cx="60" cy="60" r="56" fill="var(--primary-soft)" />
      <path d="M24 88c14-2 18-14 30-16s18 8 30-6 8-26 14-30" fill="none" stroke="var(--primary)" strokeWidth="4" strokeLinecap="round" strokeDasharray="1 10" />
      <circle cx="24" cy="88" r="6" fill="var(--primary)" />
      <circle cx="54" cy="72" r="5" fill="var(--primary)" opacity="0.7" />
      <circle cx="84" cy="66" r="5" fill="var(--primary)" opacity="0.7" />
      <path d="M98 26v20" stroke="var(--text-muted)" strokeWidth="3" strokeLinecap="round" />
      <path d="M98 27h14l-4 5 4 5H98" fill="var(--accent)" />
    </svg>
  );
}

export function Empty({ title, body, action }: { title: string; body?: string; action?: ReactNode }) {
  return (
    <div className="empty">
      <EmptyArt />
      <h2>{title}</h2>
      {body && <p>{body}</p>}
      {action}
    </div>
  );
}
